import { Property } from "./property.model";
import { IUtm } from "./utm.interface";
import { initialState } from "../redux/reducers/root.reducer";
import {Address} from "../components/AddressSelector/Address"

export class PartialPolicy {
  email: string = "";
  phone: string = "";
  phoneCountryCode: string = "";
  agentCode: string = "";
  fromDate: string = "";
  tracking: IUtm | null = initialState.utm;
  properties: Array<Property> | null = null;
}

export class Policy {
  id : number = 0;
  title: string = "";
  companyName : string = "";
  firstName: string = "";
  lastName: string = "";
  address: Address = new Address();
  email: string = "";
  phone: string = "";
  phoneCountryCode: string = "";
  agentCode: string = "";
  fromDate: string = "";
  tracking: IUtm | null = initialState.utm;
  properties: Array<Property> | null = null;
}
